"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _StyledSettingsComponents = require("./StyledSettingsComponents");

var _Row = _interopRequireDefault(require("./Row"));

var _ColorPicker = _interopRequireDefault(require("./ColorPicker"));

var _Input = _interopRequireDefault(require("./Input"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    & > div:first-of-type {\n        margin-right: 10px;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StrokeContainer = _styledComponents.default.div(_templateObject());

var ColorPanel =
/*#__PURE__*/
function (_Component) {
  _inherits(ColorPanel, _Component);

  function ColorPanel() {
    _classCallCheck(this, ColorPanel);

    return _possibleConstructorReturn(this, _getPrototypeOf(ColorPanel).apply(this, arguments));
  }

  _createClass(ColorPanel, [{
    key: "render",
    value: function render() {
      var type = this.props.type;
      return _react.default.createElement(_StyledSettingsComponents.Panel, null, _react.default.createElement(_Row.default, {
        label: "\u0417\u0430\u043B\u0438\u0432\u043A\u0430"
      }, _react.default.createElement(_ColorPicker.default, null)), type !== 'qr' && _react.default.createElement(_Row.default, {
        label: "\u041E\u0431\u0432\u043E\u0434\u043A\u0430"
      }, _react.default.createElement(StrokeContainer, null, _react.default.createElement(_ColorPicker.default, {
        prop: "stroke"
      }), _react.default.createElement(_Input.default, {
        prop: "strokeWidth",
        isNumber: true,
        small: "\u0442\u043E\u043B\u0449\u0438\u043D\u0430"
      }))));
    }
  }]);

  return ColorPanel;
}(_react.Component);

exports.default = ColorPanel;
ColorPanel.propTypes = {
  type: _propTypes.default.string
};